/**
 * Loja de produtos digitais na vitrine.
 *
 * Location: src/lib
 * Why: a vitrine é montada por servidor (`/loja/:serverId/...`), e a loja
 * digital não tem servidor. Em vez de reescrever cada template, ela usa um
 * "servidor" fixo, `produtos`, que lista o catálogo inteiro: `/loja/produtos`,
 * `/loja/produtos/:categoria/produto/:produto`. Na hora de pedir à API, esse
 * segmento vira "sem filtro de servidor".
 */

export const SEM_SERVIDOR = 'produtos';

export type TipoDeEntrega = 'COMMAND' | 'FILE' | 'LICENSE_KEY';

export const ehLojaDigital = (store?: { gameType?: string | null } | null): boolean => store?.gameType === 'DIGITAL';

/** O servidor como a API entende: o segmento fixo da loja digital não filtra nada. */
export const servidorNaApi = (serverId?: string | null): string | undefined =>
  serverId && serverId !== SEM_SERVIDOR ? serverId : undefined;

export const ehEntregaDigital = (kind?: string | null): boolean => !!kind && kind !== 'COMMAND';

/** O nome que a loja mostra do comprador: na loja digital o nick é gerado, então vai o nome. */
export const nomeNaLoja = (
  user: { name?: string | null; username?: string | null } | null | undefined,
  store?: { gameType?: string | null } | null,
): string => (ehLojaDigital(store) ? user?.name || user?.username || '' : user?.username || '')
